// Endpoints here are unauthenticated (see SecurityConfiguration's permitAll for /api/meta/**),
// so no Authorization header is sent, matching the pattern used for login/register.

export function getAppVersion() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/meta/version';
    return fetch(api_path).then(response => {
        return response.ok ? response.json() : null;
    });
}

export function getReleaseNotes() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/meta/release-notes';
    return fetch(api_path).then(response => {
        return response.ok ? response.json() : [];
    });
}
